<template>
    <div>
        <md-card>
            <md-card-content>
                <div class="md-layout">
                    <div class="md-layout-item md-size-100">
                        <md-table v-if="tableData.length > 0 " v-model="tableData" 
                        class="md-container-custom paginated-table" table-header-color="green" md-fixed-header>
                            <md-table-row slot="md-table-row" slot-scope="{ item }">            
                                <md-table-cell md-label="Email" >
                                    <span v-if="item.reqBody && item.reqBody.error.payment_method">
                                        {{ item.reqBody.error.payment_method.billing_details.name }}
                                    </span>
                                    <span v-else-if="item.email">{{ item.email }}</span>
                                    <span v-else>{{ email }}</span>
                                </md-table-cell>
                                <md-table-cell md-label="Message" >{{ item.message }}</md-table-cell>
                                <md-table-cell md-label="Created On">{{ HumanReadableDateFormat(item.created_at) }}</md-table-cell>
                            </md-table-row>
                        </md-table>
                        <h4 v-if="tableData.length == 0">No data found.</h4>
                    </div>
                </div>
            </md-card-content>
        </md-card>
    </div>
</template>
<script>
import PaymentService from "../../../services/SuperAdmin/PaymentService";

export default {
  components: {
  },
  data() {
    return {
      isDisabled: false,
      tableData: [],
      coupon: "",
    };
  },
  methods: {
      errorList() {
        this.isDisabled = true;
        PaymentService.errorList()
          .then((response) => {
            this.isDisabled = false;
            this.tableData = response.data.data;
            this.$toast.success(response.data.respones_msg);
          }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
          });
      },
  },
  beforeMount() {
    this.errorList();
  },
};
</script>